import { createSlice } from "@reduxjs/toolkit";

export const databaseListGlobalState = createSlice({
  name: "databaseListGlobalState",
  initialState: {
    openDbAccordionId: "",
  },
  reducers: {
    setDbAccordionDbId: (state, actions) => {
      state.openDbAccordionId = actions.payload.dbId;
    },
  },
});
export const { setDbAccordionDbId } = databaseListGlobalState.actions;

export default databaseListGlobalState.reducer;
